import reducer from './domainSuggestionsReducer';
import * as actions from './domainSuggestionsActions';
import * as selectors from './domainSuggestionsSelectors';

export { actions, reducer, selectors };
